import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Dialog,
  DialogTitle,
  Divider,
  DialogContent,
  Button,
  DialogActions,
  Tabs,
  AppBar,
  Tab,
  ThemeProvider,
  Typography,
  TextField,
  MenuItem,
  Card,
  CardContent,
  ListItemText,
  List,
  ListItemIcon,
} from "@material-ui/core";
import * as React from "react";
import { colors, isEmpty, getMomentDate } from "../constants/constants";
import TabPanel from "../components/TabPanel";
import { defaultTheme } from "../utils/theme";
import TableComponent from "../components/TableComponent";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import {
  EMAIL_NOTIFICATIONS_COLUMNS,
  SMS_NOTIFICATIONS_COLUMNS,
} from "../constants/tableColumns";
import { NOTIFICATION_TYPES } from "../constants/constants";
import { NotificationService } from "../services/NotificationService";
import { EventEmitter } from "../events/EventEmitter";
import { CompaniesService } from "../services/CompaniesService";
import emptyTrash from "../assets/images/empty_trash.png";
import { SNACKBAR_TYPE } from "../components/SnackBarComponent";
import GenericDialog from "./GenericDialog";
import { types } from "./AddCompanyDialog";
import LoadingComponents from "../components/LoadingComponents";
import { EMAIL_REG_EXP } from "../constants/constants";
import HasMutablePermission from "../auth/HasMutablePermission";
import { AuthConsumer } from "../routes/AuthContext";
import PersonAvatorIcon from "@material-ui/icons/Person";
import PeopleAvatorIcon from "@material-ui/icons/People";
const drawerWidth = 340;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: 5,
      width: "100%",
      height: 55,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
    appBar: {
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    menuHideButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    margin: {
      margin: theme.spacing(1),
    },
    menuShowButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "visible",
      },
      color: "black",
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    avatar: {
      backgroundColor: colors.primaryColor,
      color: "#ffff",
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
    drawerPaper: {
      width: drawerWidth,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },

    rootCard: {
      minWidth: 275,
      margin: 10,
    },
    bullet: {
      display: "inline-block",
      margin: "0 2px",
      transform: "scale(0.8)",
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
  });
export const TAB_PANELS = {
  EMAIL_NOTIFICATION_PANEL: 0,
  SMS_NOTIFICATION_PANEL: 1,
  HISTORY_NOTIFICATION_PANEL: 2,
};
interface Props extends WithStyles<typeof styles> {
  open: any;
  dialogTitle: any;
  onClose: any;
  profileData: any;
  companies: any;
}
class ManageNotificationsDialog extends React.Component<Props> {
  state = {
    companies: Array<any>(),
    value: 0,
    selectedCompany: { _id: "", name: "" },
    notificationData: { emailGroup: Array<any>(), smsGroup: Array<any>() },
    notificationHistory: Array<any>(),
    historyData: Array<any>(),
    openConfirmationDialog: false,
    emailDetails: { fullName: "", email: "", rawData: { _id: "" } },
    smsDetails: { name: "", rawData: { _id: "" } },
    groupName: "",
    deletingObject: { row: { fullName: "", email: "", name: "" }, tabType: 0 },
    updatingEmail: false,
    updatingSMS: false,
    isLoading: false,
  };
  handleClose = () => {
    this.setState({
      openConfirmationDialog: false,
    });
  };
  componentDidMount = () => {
    this.getCompanies();
  };

  componentDidUpdate = (prevProps: any) => {};

  getCompanies = () => {
    let companiesService: CompaniesService = new CompaniesService();
    this.setState({
      isLoading: true,
    });
    companiesService.getCompanies().then((resp) => {
      this.setState({
        isLoading: false,
      });
      if (resp && resp.success && resp.companies) {
        this.setState({
          companies: resp.companies,
        });
      } else {
        this.setState({
          showCompanies: false,
          showToolBarButton: false,
        });
        if (resp && resp.message) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            show: true,
            type: SNACKBAR_TYPE.ERROR,
            message: resp.message,
          });
        }
      }
    });
  };

  getNotifticationData = () => {
    let notificationService: NotificationService = new NotificationService();
    this.setState({
      isLoading: true,
    });
    notificationService
      .getNoficationData(this.state.selectedCompany._id)
      .then((resp) => {
        this.setState({
          isLoading: false,
        });
        if (resp && resp.success) {
          this.setState({
            notificationData: resp.data,
          });
        }
      });
  };
  getNotifticationHistory = () => {
    let notificationService: NotificationService = new NotificationService();
    this.setState({
      isLoading: true,
    });
    notificationService
      .getNoficationHistory(this.state.selectedCompany._id)
      .then((resp) => {
        this.setState({
          isLoading: false,
        });
        if (resp && resp.success) {
          this.setState({
            notificationHistory: resp.data,
          });
        }
      });
  };
  addEmailGroupData = () => {
    let notificationService: NotificationService = new NotificationService();
    this.setState({
      isLoading: true,
    });
    notificationService
      .addToEmailGroup(this.state.selectedCompany._id, this.state.emailDetails)
      .then((resp) => {
        this.setState({
          isLoading: false,
        });
        if (resp && resp.success) {
          this.setState({
            notificationData: resp.data,
            emailDetails: { fullName: "", email: "" },
          });
        }
      });
  };
  addSMSGroupData = () => {
    let notificationService: NotificationService = new NotificationService();
    this.setState({
      isLoading: true,
    });
    notificationService
      .addToSMSGroup(this.state.selectedCompany._id, this.state.smsDetails.name)
      .then((resp) => {
        this.setState({
          isLoading: false,
        });
        if (resp && resp.success) {
          this.setState({
            notificationData: resp.data,
            smsDetails: { name: "" },
          });
        }
      });
  };
  deleteFromEmailGroup = () => {
    let notificationService: NotificationService = new NotificationService();
    let emailDetails = {
      fullName: this.state.deletingObject.row.fullName,
      email: this.state.deletingObject.row.email,
    };
    this.setState({
      isLoading: true,
    });
    notificationService
      .deleteFromEmailGroup(this.state.selectedCompany._id, emailDetails)
      .then((resp) => {
        this.setState({
          isLoading: false,
        });
        if (resp && resp.success) {
          this.setState({
            notificationData: resp.data,

            deletingObject: {},
          });
        }
      });
  };
  deleteFromSMSGroup = () => {
    let notificationService: NotificationService = new NotificationService();
    this.setState({
      isLoading: true,
    });
    notificationService
      .deleteFromSMSGroup(
        this.state.selectedCompany._id,
        this.state.deletingObject.row
      )
      .then((resp) => {
        this.setState({
          isLoading: false,
        });
        if (resp && resp.success) {
          this.setState({
            notificationData: resp.data,
            emailDetails: { fullName: "", email: "" },
            deletingObject: {},
          });
        }
      });
  };
  updateFromEmailGroup = () => {
    let originalEmailDetails = this.state.notificationData.emailGroup.filter(
      (data: any) => {
        return data._id === this.state.emailDetails.rawData._id;
      }
    );
    if (originalEmailDetails.length > 0) {
      let originalEmailDetail = originalEmailDetails[0];
      originalEmailDetail.fullName = this.state.emailDetails.fullName;
      originalEmailDetail.email = this.state.emailDetails.email;
    }
    let notificationService: NotificationService = new NotificationService();
    this.setState({
      isLoading: true,
    });
    notificationService
      .updateFromEmailGroup(
        this.state.selectedCompany._id,
        this.state.notificationData
      )
      .then((resp) => {
        this.setState({
          isLoading: false,
          updatingEmail: false,
        });
        if (resp && resp.success) {
          this.setState({
            notificationData: resp.data,
            emailDetails: { fullName: "", email: "" },
            deletingObject: {},
          });
        }
      });
  };
  updateFromSMSGroup = () => {
    let notificationService: NotificationService = new NotificationService();

    let indexToRemove = -1;
    this.state.notificationData.smsGroup.map((data: any, index: any) => {
      if (data._id === this.state.smsDetails.rawData._id) {
        indexToRemove = index;
      }
      return null;
    });
    let notificationData = this.state.notificationData;
    if (indexToRemove > -1) {
      notificationData.smsGroup.splice(indexToRemove, 1);
      notificationData.smsGroup.push(this.state.smsDetails.name);
    }
    this.setState({
      isLoading: true,
    });
    this.setState({
      isLoading: false,
    });
    notificationService
      .updateFromSMSGroup(this.state.selectedCompany._id, notificationData)
      .then((resp) => {
        this.setState({
          isLoading: false,
        });
        if (resp && resp.success) {
          this.setState({
            notificationData: resp.data,
            smsDetails: { name: "", rawData: {} },
            deletingObject: {},
            updatingSMS: false,
          });
        }
      });
  };
  getHistoryData = () => {};
  handleAddEmailGroup = () => {
    this.addEmailGroupData();
  };
  handleAddSMSGroup = () => {
    this.addSMSGroupData();
  };
  handleUpdateEmailGroup = () => {
    this.updateFromEmailGroup();
  };
  handleUpdateSMSGroup = () => {
    this.updateFromSMSGroup();
  };
  handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    this.setState({ value: newValue });
  };
  onEditRow = (row: any, tabType: any) => {
    switch (tabType) {
      case TAB_PANELS.EMAIL_NOTIFICATION_PANEL:
        this.setState({
          emailDetails: {
            fullName: row.fullName,
            email: row.email,
            rawData: row,
          },
          updatingEmail: true,
        });
        break;
      case TAB_PANELS.SMS_NOTIFICATION_PANEL:
        this.setState({
          smsDetails: { name: row, rawData: row },
          updatingSMS: true,
        });
        break;
    }
  };
  deleteAllSelectedRows = (selectedList: any) => {
    let notificationService: NotificationService = new NotificationService();
    this.setState({
      isLoading: true,
    });
    notificationService
      .deleteAllSelectedFromEmailGroup(
        this.state.selectedCompany._id,
        selectedList
      )
      .then((resp) => {
        this.setState({
          isLoading: false,
        });
        if (resp && resp.success) {
          this.setState({
            notificationData: resp.data,

            deletingObject: {},
          });
        }
      });
  };
  deleteAllSelectedSMSRows = (selectedList: any) => {
    let notificationService: NotificationService = new NotificationService();
    this.setState({
      isLoading: true,
    });
    notificationService
      .deleteAllSelectedFromSmsGroup(
        this.state.selectedCompany._id,
        selectedList
      )
      .then((resp) => {
        this.setState({
          isLoading: false,
        });
        if (resp && resp.success) {
          this.setState({
            notificationData: resp.data,

            deletingObject: {},
          });
        }
      });
  };
  onDeleteRow = (row: any, tabType: any) => {
    this.setState({
      deletingObject: { row: row, tabType: tabType },
      openConfirmationDialog: true,
    });
  };
  createEmailNotificationUniqueIdentifier = (row: any, index: any) => {
    return `${row._id}`;
  };
  createEmailNotificationData = (row: any) => {
    return {
      fullName: row.fullName,
      email: row.email,
      actions: "Actions",
    };
  };
  createSmsNotificationUniqueIdentifier = (row: any, index: any) => {
    return `${row}`;
  };
  createSmsNotificationData = (row: any) => {
    return {
      name: row,
      actions: "Actions",
    };
  };
  handleSelectedItem = (event: any) => {
    let value = event.target.value;
    let selectedCompany = this.state.companies.filter((company: any) => {
      return company.name === value;
    });
    if (selectedCompany && selectedCompany.length > 0) {
      this.setState(
        {
          selectedCompany: selectedCompany[0],
        },
        () => {
          this.getNotifticationData();
          this.getNotifticationHistory();
        }
      );
    }
  };
  renderNoDataAvailable = (message?: any) => {
    return (
      <div
        style={{
          height: 500,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          overflow: "auto",
        }}
      >
        <img
          src={emptyTrash}
          style={{ width: 40, height: 40 }}
          alt="Empty Trash"
        />
        <Typography
          variant="h5"
          gutterBottom
          style={{ marginTop: 10, textAlign: "center" }}
        >
          {message ? message : "No data available".toUpperCase()}
        </Typography>
      </div>
    );
  };

  handleConfirmedDelete = () => {
    let deletingObject = this.state.deletingObject;
    if (!deletingObject || !deletingObject.row) {
      return;
    }
    switch (deletingObject.tabType) {
      case TAB_PANELS.EMAIL_NOTIFICATION_PANEL:
        this.deleteFromEmailGroup();
        break;
      case TAB_PANELS.SMS_NOTIFICATION_PANEL:
        this.deleteFromSMSGroup();
        break;
    }
  };

  renderConfirmationDialog = () => {
    let deletingObject = this.state.deletingObject;
    if (!deletingObject || !deletingObject.row) {
      return;
    }
    let contentMessage = { title: "", message: "" };
    switch (deletingObject.tabType) {
      case TAB_PANELS.EMAIL_NOTIFICATION_PANEL:
        contentMessage = {
          title: `Deleting ${
            deletingObject.row.fullName ? deletingObject.row.fullName : ""
          }`,
          message: "Are you sure want to delete this Email item?",
        };
        break;
      case TAB_PANELS.SMS_NOTIFICATION_PANEL:
        contentMessage = {
          title: `Deleting ${
            deletingObject.row.name ? deletingObject.row.name : ""
          }`,
          message: "Are you sure want to delete this SMS item?",
        };
        break;
    }
    return (
      <GenericDialog
        type={types.DIALOG_INFO}
        title={`Deleting ${contentMessage.title}`}
        message={`${contentMessage.message}`}
        leftButtonName={"Cancel"}
        rightButtonName={"YES"}
        open={this.state.openConfirmationDialog}
        onCancel={() => this.handleClose()}
        onOk={() => this.handleConfirmedDelete()}
        handleClose={() => this.handleClose()}
      />
    );
  };
  render() {
    const { open, dialogTitle, classes, onClose } = this.props;
    return (
      <React.Fragment>
        <AuthConsumer>
          {({ user, accessRules }) => (
            <Dialog
              fullWidth={true}
              maxWidth={"md"}
              open={open}
              onClose={onClose}
              aria-labelledby="max-width-dialog-title"
            >
              <DialogTitle id="max-width-dialog-title">
                <div
                  style={{
                    flex: "row",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Typography
                    variant="h5"
                    component="h2"
                    style={{ flex: 0.5 }}
                    gutterBottom
                  >
                    {dialogTitle}
                  </Typography>
                  <TextField
                    id="filled-select-currency"
                    select
                    style={{ flex: 0.5, color: "black" }}
                    label="Select"
                    value={
                      this.state.selectedCompany
                        ? this.state.selectedCompany.name
                        : ""
                    }
                    onChange={this.handleSelectedItem}
                    variant="outlined"
                  >
                    {this.state.companies &&
                      this.state.companies.map((company: any, index: any) => (
                        <MenuItem
                          key={index.toString()}
                          value={company.name ? company.name : ""}
                        >
                          {company.name}
                        </MenuItem>
                      ))}
                  </TextField>
                </div>
              </DialogTitle>
              <Divider />
              <DialogContent>
                {!isEmpty(this.state.selectedCompany._id) ? (
                  <div>
                    <ThemeProvider theme={defaultTheme}>
                      <AppBar position="static" color="default">
                        <Tabs
                          value={this.state.value}
                          onChange={this.handleChange}
                          variant="fullWidth"
                          TabIndicatorProps={{
                            style: { background: "orange", height: 3 },
                          }}
                          aria-label="full width tabs example"
                        >
                          <Tab label="Email Notifications" />
                          <Tab label="SMS Notifications" />
                          <Tab label="Notification History" />
                        </Tabs>
                      </AppBar>
                    </ThemeProvider>
                    <TabPanel value={this.state.value} index={0}>
                      <div>
                        <div
                          style={{
                            width: "100%",
                            justifyContent: "space-evenly",
                            alignItems: "center",
                            display: "flex",
                          }}
                        >
                          <TextField
                            variant={"outlined"}
                            style={{ flex: 0.5, marginRight: 10 }}
                            id="standard-basic"
                            label="Full Name"
                            value={this.state.emailDetails.fullName}
                            placeholder="Full Name"
                            onChange={(event: any) => {
                              let emailDetails = this.state.emailDetails;
                              emailDetails.fullName = event.target.value;
                              this.setState({
                                emailDetails: emailDetails,
                              });
                            }}
                          />
                          <TextField
                            variant={"outlined"}
                            style={{ flex: 0.5, marginLeft: 10 }}
                            id="standard-basic"
                            label="Email"
                            value={this.state.emailDetails.email}
                            placeholder="Email"
                            error={
                              isEmpty(this.state.emailDetails.email)
                                ? false
                                : !this.state.emailDetails.email.match(
                                    EMAIL_REG_EXP
                                  )
                            }
                            helperText={
                              !isEmpty(this.state.emailDetails.email) &&
                              !this.state.emailDetails.email.match(
                                EMAIL_REG_EXP
                              )
                                ? "Email not valid."
                                : ""
                            }
                            onChange={(event: any) => {
                              let emailDetails = this.state.emailDetails;
                              emailDetails.email = event.target.value;
                              this.setState({
                                emailDetails: emailDetails,
                              });
                            }}
                          />
                          {this.state.updatingEmail ? (
                            <div
                              style={{
                                flex: 0.5,
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                marginRight: 10,
                              }}
                            >
                              <Button
                                variant="outlined"
                                className={classes.button}
                                disabled={
                                  this.state.emailDetails.fullName &&
                                  this.state.emailDetails.email
                                    ? false
                                    : true
                                }
                                onClick={() => this.handleUpdateEmailGroup()}
                              >
                                UPDATE
                              </Button>
                              <Button
                                className={classes.button}
                                variant="outlined"
                                onClick={() =>
                                  this.setState({
                                    emailDetails: {
                                      fullName: "",
                                      email: "",
                                      rawData: {},
                                    },
                                    updatingEmail: false,
                                  })
                                }
                              >
                                CANCEL
                              </Button>
                            </div>
                          ) : (
                            <Button
                              variant="outlined"
                              style={{ flex: 0.5, marginRight: 10 }}
                              className={classes.button}
                              disabled={
                                this.state.emailDetails.fullName &&
                                this.state.emailDetails.email
                                  ? false
                                  : true
                              }
                              onClick={() => this.handleAddEmailGroup()}
                            >
                              ADD EMAIL NOTIFICATION
                            </Button>
                          )}
                        </div>
                        {this.state.notificationData &&
                          this.state.notificationData.smsGroup && (
                            <TableComponent
                              tableName={"Manage Notifications"}
                              columns={EMAIL_NOTIFICATIONS_COLUMNS}
                              data={this.state.notificationData.emailGroup}
                              createData={this.createEmailNotificationData}
                              deleteAllAction={"notificationSMS:deleteAll"}
                              uniqueIdentifier={
                                this.createEmailNotificationUniqueIdentifier
                              }
                              deleteAllSelected={this.deleteAllSelectedRows}
                              company={this.state.selectedCompany}
                              actions={[
                                {
                                  icon: <EditIcon fontSize="small" />,
                                  name: TAB_PANELS.EMAIL_NOTIFICATION_PANEL,
                                  action: this.onEditRow,
                                  disabled: this.state.updatingEmail,
                                  visible: HasMutablePermission({
                                    role: user.role,
                                    accessRules: accessRules,
                                    perform: "notifications:edit",
                                    data: user.role,
                                  }),
                                },
                                {
                                  icon: <DeleteIcon fontSize="small" />,
                                  name: TAB_PANELS.EMAIL_NOTIFICATION_PANEL,
                                  action: this.onDeleteRow,
                                  visible: HasMutablePermission({
                                    role: user.role,
                                    accessRules: accessRules,
                                    perform: "notifications:delete",
                                    data: user.role,
                                  }),
                                },
                              ]}
                            />
                          )}
                      </div>
                    </TabPanel>
                    <TabPanel value={this.state.value} index={1}>
                      <div>
                        <div
                          style={{
                            justifyContent: "flex-end",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <TextField
                            variant={"outlined"}
                            style={{ flex: 0.5, marginRight: 10 }}
                            id="standard-basic"
                            label="Group Name"
                            value={this.state.smsDetails.name}
                            placeholder="Group Name"
                            onChange={(event: any) => {
                              let smsDetails = this.state.smsDetails;
                              smsDetails.name = event.target.value;
                              this.setState({
                                smsDetails: smsDetails,
                              });
                            }}
                          />
                          {this.state.updatingSMS ? (
                            <div
                              style={{
                                flex: 0.5,
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                marginRight: 10,
                              }}
                            >
                              <Button
                                style={{ flex: 0.5 }}
                                variant="outlined"
                                className={classes.button}
                                disabled={
                                  this.state.smsDetails.name ? false : true
                                }
                                onClick={() => this.handleUpdateSMSGroup()}
                              >
                                UPDATE
                              </Button>
                              <Button
                                style={{ flex: 0.5 }}
                                variant="outlined"
                                className={classes.button}
                                onClick={() =>
                                  this.setState({
                                    smsDetails: { name: "", rawData: {} },
                                    updatingSMS: false,
                                  })
                                }
                              >
                                CANCEL
                              </Button>
                            </div>
                          ) : (
                            <Button
                              variant="outlined"
                              style={{ flex: 0.5, marginRight: 10 }}
                              className={classes.button}
                              disabled={
                                this.state.smsDetails.name ? false : true
                              }
                              onClick={() => this.handleAddSMSGroup()}
                            >
                              ADD SMS NOTIFICATION
                            </Button>
                          )}
                        </div>
                        {this.state.notificationData &&
                        this.state.notificationData.smsGroup ? (
                          <TableComponent
                            tableName={"Manage SMSs"}
                            columns={SMS_NOTIFICATIONS_COLUMNS}
                            data={this.state.notificationData.smsGroup}
                            company={this.state.selectedCompany}
                            uniqueIdentifier={
                              this.createSmsNotificationUniqueIdentifier
                            }
                            deleteAllSelected={this.deleteAllSelectedSMSRows}
                            createData={this.createSmsNotificationData}
                            deleteAllAction={"notificationsEmails:deleteAll"}
                            actions={[
                              {
                                icon: <EditIcon fontSize="small" />,
                                name: TAB_PANELS.SMS_NOTIFICATION_PANEL,
                                action: this.onEditRow,
                                disabled: this.state.updatingSMS,
                                visible: HasMutablePermission({
                                  role: user.role,
                                  accessRules: accessRules,
                                  perform: "notifications:edit",
                                  data: user.role,
                                }),
                              },
                              {
                                icon: <DeleteIcon fontSize="small" />,
                                name: TAB_PANELS.SMS_NOTIFICATION_PANEL,
                                action: this.onDeleteRow,
                                visible: HasMutablePermission({
                                  role: user.role,
                                  accessRules: accessRules,
                                  perform: "notifications:delete",
                                  data: user.role,
                                }),
                              },
                            ]}
                          />
                        ) : (
                          this.renderNoDataAvailable()
                        )}
                      </div>
                    </TabPanel>
                    <TabPanel value={this.state.value} index={2}>
                      {this.state.notificationHistory &&
                        this.state.notificationHistory.map(
                          (histroyItem: any) => {
                            return (
                              <Card className={classes.rootCard}>
                                <CardContent>
                                  <div
                                    style={{
                                      width: "100%",
                                      flexDirection: "row",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <ListItemText
                                      primary="Sent On"
                                      secondary={getMomentDate(
                                        histroyItem.dateSent
                                      )}
                                    />
                                    <ListItemText
                                      primary="Notification Type"
                                      style={{
                                        direction: "rtl",
                                        textAlign: "right",
                                      }}
                                      secondary={histroyItem.type}
                                    />
                                  </div>

                                  <Divider />
                                  <List className={classes.root}>
                                    {histroyItem.sentTo.map(
                                      (sentToItem: any, index: any) => {
                                        return (
                                          <div key={index.toString()}>
                                            <div
                                              style={{
                                                display: "flex",
                                                margin: 10,
                                                flexDirection: "row",
                                              }}
                                            >
                                              <ListItemIcon>
                                                {histroyItem.type ===
                                                NOTIFICATION_TYPES.EMAIL ? (
                                                  <PersonAvatorIcon />
                                                ) : (
                                                  <PeopleAvatorIcon />
                                                )}
                                              </ListItemIcon>
                                              <ListItemText
                                                primary={sentToItem}
                                              />
                                            </div>
                                            <Divider variant={"inset"} />
                                          </div>
                                        );
                                      }
                                    )}
                                  </List>
                                  <Typography variant="body1" component="p">
                                    {histroyItem.details.content}
                                  </Typography>
                                </CardContent>
                              </Card>
                            );
                          }
                        )}
                    </TabPanel>
                  </div>
                ) : (
                  this.renderNoDataAvailable("Select a company")
                )}
                {this.renderConfirmationDialog()}
                <LoadingComponents isLoading={this.state.isLoading} />
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose}>Close</Button>
              </DialogActions>
            </Dialog>
          )}
        </AuthConsumer>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(ManageNotificationsDialog);
